import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
};

export function NextEpisodeDialog({ open, onClose }: Props) {
  const theme = useTheme();

  return (
    <Dialog onClose={onClose} fullWidth maxWidth="md" open={open}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        You are now validating another episode!
        <Button onClick={onClose} sx={{ minWidth: 0 }}>
          <Close sx={{ color: theme.palette.common.black }} />
        </Button>
      </DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions sx={{ padding: 3, paddingTop: 0, paddingBottom: 2 }}>
        <Button onClick={onClose}>Got it!</Button>
      </DialogActions>
    </Dialog>
  );
}
